import { createSlice } from '@reduxjs/toolkit';
import { queryHistoryOrder } from './work-history-thunk';

export const workHistorySlice = createSlice({
  name: 'work-history',
  initialState: {
    enquiryLayout: [],

    // Using for search section
    searchData: {
      filter: '',
      finish: '',
      found: [{}],
      /*
      found: [
        {
          work_no: "C003",
          work_date: "2021-07-18T10:14:25.753Z",
          due_date:"2021-07-27T10:14:25.753Z", 
          product_name: "สินค้าตัวอย่าง",
          contact_name: "สวัสดี",
          description:"ข้อความตัวอย่าง",
          order_qty:250,
          order_unit: "กล่อง",
          qty_total: 120,
          qty_ng: 18,
          qty_good: 102,
          finish_date: "2021-07-31T10:14:25.753Z", 
          work_status: "Y",
          work_remark: "ทำงานได้ดีมาก"
        }
      ]
      */
    },

  },

  reducers: {
    setEnquiryLaout: (state, action) => {
      state.enquiryLayout = action.payload;
    },

    setSearchData: (state, action) => {
      state.searchData = action.payload;
    },

  },

  extraReducers: (builder) => {
    builder.addCase(queryHistoryOrder.fulfilled, (state, action) => {
      // console.info(action);
      state.searchData.found = action.payload;
    });
  }

});

export const actions = workHistorySlice.actions;
export default workHistorySlice.reducer;
